// How It Works page constants
// Following the same pattern as about-us-sections.constant.tsx

import {
  howItWorksHeroImage,
  createAccountIcon,
  invoiceIcon,
  startupIcon,
  sendDocumentsIcon,
  carIcon,
  strategyIcon,
  paymentIcon,
  toolsIcon,
  downloadIcon,
  rightArrowIcon,
  ctaBackgroundImage
} from '../components/images/howItWorksImages';

// Main hero title for the page
export const HOW_IT_WORKS_MAIN_TITLE = 'HOW_IT_WORKS_MAIN_TITLE';

// Image assets for How It Works page
export const howItWorksImages = {
  heroImage: howItWorksHeroImage,
  ctaBackground: ctaBackgroundImage
};

// Feature icons
export const featureIcons = {
  createAccount: createAccountIcon,
  invoice: invoiceIcon,
  startup: startupIcon,
  sendDocuments: sendDocumentsIcon,
  car: carIcon,
  strategy: strategyIcon,
  payment: paymentIcon,
  tools: toolsIcon
};

// UI icons
export const uiIcons = {
  download: downloadIcon,
  rightArrow: rightArrowIcon
};

// Content sections for How It Works page
export const howItWorksIntroSection = [
  {
    titleKey: 'HOW_IT_WORKS_INTRO_TITLE',
    textKeys: [
      'HOW_IT_WORKS_INTRO_DESCRIPTION'
    ]
  }
];

export const howItWorksMainSection = [
  {
    titleKey: 'HOW_IT_WORKS_MAIN_SECTION_TITLE',
    textKeys: [
      'HOW_IT_WORKS_MAIN_SECTION_DESCRIPTION'
    ]
  }
];

export const whatYouCanDoSection = [
  {
    titleKey: 'WHAT_YOU_CAN_DO_WITH_INVOZIO_TITLE',
    textKeys: [
      'WHAT_YOU_CAN_DO_WITH_INVOZIO_DESCRIPTION_1',
      'WHAT_YOU_CAN_DO_WITH_INVOZIO_DESCRIPTION_2'
    ]
  }
];

// Features data for "What You Can Do with Invozio" section
export const howItWorksFeatures = [
  {
    iconKey: 'createAccount',
    titleKey: 'FEATURE_CREATE_ACCOUNT_TITLE',
    descriptionKey: 'FEATURE_CREATE_ACCOUNT_DESCRIPTION'
  },
  {
    iconKey: 'invoice', 
    titleKey: 'FEATURE_CREATE_SEND_INVOICES_TITLE',
    descriptionKey: 'FEATURE_CREATE_SEND_INVOICES_DESCRIPTION'
  },
  {
    iconKey: 'startup',
    titleKey: 'FEATURE_EXPRESS_PAYMENT_TITLE', 
    descriptionKey: 'FEATURE_EXPRESS_PAYMENT_DESCRIPTION'
  },
  {
    iconKey: 'sendDocuments',
    titleKey: 'FEATURE_PRELIMINARY_INVOICES_TITLE',
    descriptionKey: 'FEATURE_PRELIMINARY_INVOICES_DESCRIPTION'
  },
  {
    iconKey: 'car',
    titleKey: 'FEATURE_REPORT_MILEAGE_TITLE',
    descriptionKey: 'FEATURE_REPORT_MILEAGE_DESCRIPTION'
  },
  {
    iconKey: 'strategy',
    titleKey: 'FEATURE_TRAVEL_EXPENSES_TITLE',
    descriptionKey: 'FEATURE_TRAVEL_EXPENSES_DESCRIPTION'
  },
  {
    iconKey: 'payment',
    titleKey: 'FEATURE_ALLOWANCES_TITLE',
    descriptionKey: 'FEATURE_ALLOWANCES_DESCRIPTION'
  },
  {
    iconKey: 'tools',
    titleKey: 'FEATURE_MATERIAL_EXPENSES_TITLE',
    descriptionKey: 'FEATURE_MATERIAL_EXPENSES_DESCRIPTION'
  }
];

// CTA section
export const ctaSection = [
  {
    titleKey: 'CTA_READY_TO_GET_STARTED_TITLE',
    textKeys: [
      'CTA_READY_TO_GET_STARTED_DESCRIPTION'
    ]
  }
];
